import FeedStatus from './feed-status'

export default FeedStatus
